import { nowIso } from "../constants";
import type { MemoryCandidate } from "../types/app";
import { createId } from "../utils/id";

interface Props {
  candidates: MemoryCandidate[];
  onSave: (content: string, temporary?: boolean) => void;
}

export function MemoryCandidates({ candidates, onSave }: Props) {
  if (!candidates.length) return null;
  return (
    <section className="panel">
      <h2>記憶候補</h2>
      {candidates.map((candidate) => (
        <article className="memory-candidate" key={candidate.id || createId("candidate")}>
          <p>{candidate.content}</p>
          <button type="button" onClick={() => onSave(candidate.content)}>記憶する</button>
          <button type="button" onClick={() => onSave(candidate.content, true)}>今回だけ使う</button>
          <button
            type="button"
            onClick={() => {
              const edited = window.prompt("編集して記憶", candidate.content);
              if (edited?.trim()) onSave(edited.trim());
            }}
          >
            編集して記憶
          </button>
          <button type="button" onClick={() => undefined}>記憶しない</button>
        </article>
      ))}
      <span hidden>{nowIso()}</span>
    </section>
  );
}
